import React, { Suspense, lazy } from 'react'
import { AppBar, Container, Toolbar, Grid, Typography, Hidden } from '@material-ui/core';
import Logo from './Logo'
import { NavHashLink } from 'react-router-hash-link';

const HelpWidget = lazy(() => import('../Widget/HelpWidget'))
const OffersWidget = lazy(() => import('../Widget/OffersWidget'))

const AvatarWidget = lazy(() => import('../Widget/AvatarWidget'))

const SimpleNav = () => {


    return (
        <React.Fragment>

            {/* This bar is  visible on other than home page */}
            <AppBar position="sticky" >
                <Toolbar>
                    <Container>
                        <Grid container>
                            <Grid item sm={6} xs={7} style={{ display: "flex", justifyContent: 'flex-start', alignItems: 'center' }}>
                                <Logo />
                            </Grid>

                            <Grid item sm={6} xs={5} style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                <Hidden only={"xs"}>
                                    <NavHashLink smooth to='#download' style={{ textDecoration: 'none', color: '#fff' }} >
                                        <Typography aria-label="download app" component="p" variant="body1" align="right">
                                            Download App
                                        </Typography>
                                    </NavHashLink>
                                </Hidden>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <HelpWidget />
                                </Suspense>

                                <Hidden only={"xs"}>
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <OffersWidget />
                                    </Suspense>
                                </Hidden>

                                <Suspense fallback={<div> Loading...</div>}>
                                    <AvatarWidget />
                                </Suspense>

                            </Grid>
                        </Grid>
                    </Container>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    )
}


export default SimpleNav
